import React, { useEffect, useState } from 'react'
import TinyChip from '../chips/tiny-chip'
import { green } from '@mui/material/colors'
import { Button, Chip, TextField, Toolbar, Tooltip, Slide } from '@mui/material'
import { MdCheckCircleOutline } from "react-icons/md";
import { formatToBRL } from '@/helpers/formatter';

export default function RaffleNumbersSelect({
    numbersArray,
    setQuantity,
    raffle,
    onChange,
    setShowModalGateway
}) {

    const [selectedNumbers, setSelectedNumbers] = useState([]);
    const [filteredNumbers, setFilteredNumbers] = useState([]);

    const [search, setSearch] = useState('');

    const handleSelectNumber = (item) => {

        if (selectedNumbers.includes(item.number)) {
            setSelectedNumbers(selectedNumbers.filter(number => number !== item.number))
        } else {
            if (item.client_name) {
                return
            }
            setSelectedNumbers([...selectedNumbers, item.number])
        }
    }

    const handleSearch = (event) => {
        setSearch(event.target.value)
    }

    useEffect(() => {
        if (search) {
            let tempSearchArray = search.split(',')
            setFilteredNumbers(numbersArray.filter(item => tempSearchArray.includes(item.number.toString())))
        } else {
            setFilteredNumbers([])
        }
    }, [search])

    useEffect(() => {
        if (!setQuantity) {
            return;
        }
        setQuantity(selectedNumbers.length)
    }, [selectedNumbers])

    useEffect(() => {
        onChange(selectedNumbers)
    }, [selectedNumbers]);


    return (
        <div style={{ marginLeft: -8, marginRight: -8 }}>
            {
                selectedNumbers.length > 0 &&
                <NumbersCartBottom selectedNumbers={selectedNumbers} raffle={raffle} setShowModalGateway={setShowModalGateway} />
            }
            <TextField
                label="Digite um ou mais números"
                variant="filled"
                size="small"
                style={{ width: '100%', backgroundColor: 'white', borderRadius: 10 }}
                value={search}
                onChange={handleSearch}
            />
            <div style={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center", justifyContent: "center", marginTop: 10 }}>
                {
                    (filteredNumbers?.length > 0 ? filteredNumbers : numbersArray).map((item, index) => (
                        <Tooltip key={index} title={`${item.client_name ? item.client_name : ''}`} onClick={() => handleSelectNumber(item)}>
                            <Chip
                                key={index}
                                label={`${String(item.number).padStart(String(raffle.numbers_quantity).length - 1, '0')}`}
                                variant='filled'
                                color={(!item.paid && item.client_name) ? 'error' : !item.client_name ? selectedNumbers.includes(item.number) ? 'info' : 'secondary' : 'primary'}
                                style={{ fontWeight: 700, minWidth: 60, maxWidth: 70, width: '100%', margin: 1, cursor: 'pointer' }} />
                        </Tooltip>
                    ))
                }
            </div>
        </div>
    )
}

const NumbersCartBottom = ({ selectedNumbers, raffle, setShowModalGateway }) => {
    return (
        <Slide direction="up" in={true} mountOnEnter unmountOnExit>
            <div style={{ position: 'fixed', zIndex: 9999999, bottom: 0, left: 0, right: 0, backgroundColor: "#cbcfd4", boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)", padding: 10, maxWidth: 620, marginLeft: 'auto', marginRight: 'auto', borderRadius: '10px 10px 0 0' }}>
                <div style={{ maxHeight: 80, overflowX: "auto", overflowY: "auto" }}>
                    {
                        selectedNumbers.map((item, index) => (
                            <Chip key={index} label={`${String(item).padStart(2, '0')}`} variant='filled' color='secondary' style={{ fontWeight: 700, minWidth: 60, maxWidth: 70, width: '100%', margin: 1 }} />
                        ))
                    }

                </div>
                <Button variant='contained' color='primary' style={{ width: '100%', marginTop: 10, fontWeight: 700, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "space-between" }} onClick={() => setShowModalGateway(true)}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                        <MdCheckCircleOutline />&nbsp;
                        Participar do sorteio
                    </div>
                    <h4 style={{ fontWeight: 700, fontSize: 14 }}>{formatToBRL(selectedNumbers.length * raffle.numbers_price)}</h4>
                </Button>
            </div>
        </Slide>
    )
}